export const eighth = '.125rem';
export const quarter = '.25rem';
export const half = '.5rem';
export const three_quarters = '.75rem';
export const normal = '1rem';
export const three_halves = '1.5rem';
export const double = '2rem';
export const five_halves = '2.5rem';
export const triple = '3rem';
export const quadruple = '4rem';
export const pentuple = '5rem';
export const sextuple = '6rem';
export const decuple = '10rem';
